import './BookingConfirmation.scss';

import { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import useWindowDimensions from 'helpers/useWindowDimensions';

import { clearForm as clearSurveyForm } from 'store/reducers/advancedSearch';
import { clearForm } from 'store/reducers/requestAppointmentForm';

import { DesktopView } from './DesktopView';
import { MobileView } from './MobileView';

export default function BookingConfirmation() {
  const dispatch = useDispatch();
  const location = useLocation();
  const { width } = useWindowDimensions();
  const isMobile = width < 600;
  const finishSignup = location.pathname.includes('signup');

  useEffect(
    () => () => {
      if (!finishSignup) {
        dispatch(clearForm());
      }
      dispatch(clearSurveyForm());
      sessionStorage.removeItem('requestAppointmentForm');
    },
    [],
  );

  return (
    <>
      <Helmet title="Booking confirmation | PawCare">
        <link
          rel="canonical"
          href="https://mypawcare.com/signup/booking-confirmation"
        />
      </Helmet>
      <div className="booking-confirmation">
        {isMobile && !finishSignup ? (
          <MobileView />
        ) : (
          <DesktopView finishSignup={finishSignup} />
        )}
      </div>
    </>
  );
}
